import React from 'react';
import {DataGridPro, GridColDef, GridRowModel, GridSelectionModel} from '@mui/x-data-grid-pro';
import Grid from '@mui/material/Grid';

import AddIcon from '@mui/icons-material/Add';
// import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import {FormLabel, IconButton} from '@mui/material';
import {includes} from 'lodash';

import {useFormContext} from 'react-hook-form';
import {enums} from 'types/enums';
import {useTranslation} from 'react-i18next';
import {
   ExceptIpNames,
   IIPAccessRulesSettings,
   IPAccessRulesSettingsNames,
} from 'types/diplomat/sftp/IPAccessRulesSettings';
import {NameDialog} from 'components/dialogs/NameDialog';
import {useModal} from 'common/hooks/useModal';
import {SetValueOptions} from 'components/hook-form/helpers';
import * as yup from 'common/yup';
import {ipString} from 'common/yup/customs/ip';

const columns: GridColDef[] = [
   {
      field: ExceptIpNames.access,
      //   renderCell: (params) => (params.row.recursive ? <CheckOutlined /> : ''),
      valueGetter: (p) =>
         enums.acessControlBehavior[
            p.row[ExceptIpNames.access] as keyof typeof enums.acessControlBehavior
         ],
      headerName: 'Access',
      flex: 200,
      align: 'center',
      headerAlign: 'center',
   },
   {
      field: ExceptIpNames.ip,
      headerName: 'IP Address',
      flex: 200,
      align: 'center',
      headerAlign: 'center',
      // editable: true,
      // preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
      //    const hasError = !(isIP(params.props.value) || isCidr(params.props.value));
      // return {...params.props, error: hasError};
      // },
   },
];

const _data = [
   {[ExceptIpNames.access]: 'allow', [ExceptIpNames.ip]: '10.0.1.0/24'},
   {[ExceptIpNames.access]: 'allow', [ExceptIpNames.ip]: '192.168.20.0/24'},
   {[ExceptIpNames.access]: 'allow', [ExceptIpNames.ip]: '127.0.0.1'},
];

const addIpValidationSchema = yup.object({
   name: ipString(),
});

const ExceptIPList = () => {
   const {t} = useTranslation();
   // const apiRef = React.useRef<GridApiCommon>();

   const {watch, setValue} = useFormContext<IIPAccessRulesSettings>();

   const [data, setData] = React.useState(_data);
   const [selected, setSelected] = React.useState<GridSelectionModel>();

   const {open: addOpened, handleOpen, handleClose} = useModal(false);

   const exceptIPs = watch(IPAccessRulesSettingsNames.exceptions);
   const accessBehavior = watch(IPAccessRulesSettingsNames.defaultBehavior);
   React.useEffect(() => {
      if (exceptIPs) {
         setData(
            exceptIPs.map((ip) => ({
               ip: ip!,
               access:
                  accessBehavior === enums.acessControlBehavior.enum.ALLOW
                     ? enums.acessControlBehavior.enum.DENY
                     : enums.acessControlBehavior.enum.ALLOW,
            }))
         );
      }
   }, [exceptIPs, exceptIPs?.length, accessBehavior]);

   const onAddIP = React.useCallback(
      (value: string) => {
         setValue(IPAccessRulesSettingsNames.exceptions, [...exceptIPs!, value], SetValueOptions);
         handleClose();
      },
      [data, exceptIPs, setValue, handleClose]
   );

   const remove = React.useCallback(() => {
      if (exceptIPs) {
         setValue(
            IPAccessRulesSettingsNames.exceptions,
            exceptIPs.filter((i) => !includes(selected, i)),
            SetValueOptions
         );
      }
   }, [exceptIPs, setValue, selected]);

   // const ipAdressess = useIPAddresses();
   // const [ipsToAdd, setIPsToAdd] = React.useState(ipAdressess);
   // React.useEffect(() => {
   //    if (addOpened) {
   //       setIPsToAdd(difference(ipAdressess, exceptIPs!));
   //    }
   // }, [addOpened, exceptIPs, ipAdressess]);

   return (
      <div>
         <Grid container spacing={1} justifyContent="end">
            <Grid item>
               <IconButton onClick={handleOpen}>
                  <AddIcon />
               </IconButton>
            </Grid>
            <Grid item>
               <IconButton onClick={remove} disabled={!selected?.length}>
                  <DeleteOutlineIcon />
               </IconButton>
            </Grid>
            {/* <Grid item></Grid> */}
         </Grid>

         <FormLabel>{t('Except the following:')}</FormLabel>
         <div style={{height: 200, width: '100%'}}>
            <DataGridPro
               // apiRef={apiRef as React.MutableRefObject<GridApiPro>}
               // ref={apiRef as React.MutableRefObject<GridApiCommon>}
               density="compact"
               rows={data}
               columns={columns}
               pageSize={10}
               checkboxSelection
               // experimentalFeatures={{newEditingApi: true}}
               getRowId={(row) => row.ip}
               onSelectionModelChange={(selectionModel) => setSelected(selectionModel)}
            />
         </div>

         {addOpened && (
            <NameDialog
               title={t('Add new IP')}
               label=""
               onClose={(nameObj) => {
                  if (nameObj) {
                     onAddIP(nameObj.name);
                  }
                  handleClose();
               }}
               validationSchema={addIpValidationSchema}
            />

            // <AddIpToExceptListDialog
            //    ipAdressess={ipsToAdd}
            //    onSubmit={onAddIP}
            //    onClose={() => openAdd(false)}
            // />
         )}
      </div>
   );
};

export default ExceptIPList;
